import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, VStack, Button, Link, Image, Flex } from '@chakra-ui/react';

const Services = () => {
  const { t } = useTranslation('services');
  
  return (
    <Box maxW="1200px" mx="auto" p={8} bg="white" minH="100vh">
      {/* Hero Section */}
      <Box 
        textAlign="center" 
        mb={16} 
        py={12}
        border="4px solid black"
        mx={4}
      >
        <Text 
          fontSize={{ base: "4xl", md: "6xl" }} 
          fontWeight="bold" 
          mb={6} 
          color="black"
          fontFamily="Abel"
        >
{t('hero.title')}
        </Text>
        
        <Box w="60px" h="2px" bg="black" mx="auto" mb={6} />
        
        <Text 
          fontSize={{ base: "lg", md: "xl" }} 
          textAlign="center" 
          color="black" 
          lineHeight="1.8"
          fontFamily="Source Code Pro"
        >
{t('hero.subtitle')}
        </Text>
      </Box>

      <VStack spacing={16} align="stretch" px={4}>
        
        {/* Event Photography */}
        <Box 
          bg="white"
        >
          <Flex direction={{ base: "column", lg: "row" }} align="center" gap={0}>
            <Box flex="1" p={{ base: 6, md: 10 }} position="relative">
              <Box 
                position="absolute"
                top="0"
                left="0"
                w="60px"
                h="2px"
                bg="black"
                mb={4}
              />
              
              <Box pt={6}>
                <Text 
                  fontSize="sm" 
                  color="gray.500"
                  fontFamily="Source Code Pro"
                  textTransform="uppercase"
                  letterSpacing="2px"
                  mb={2}
                >
{t('events.number')} / {t('events.label')}
                </Text>
                <Text 
                  fontSize={{ base: "3xl", md: "4xl" }} 
                  fontWeight="bold" 
                  color="black"
                  fontFamily="Abel"
                  mb={4}
                  lineHeight="1.1"
                >
{t('events.title')}
                </Text>
                <Text 
                  fontSize="lg" 
                  lineHeight="1.6"
                  color="gray.700"
                  fontFamily="Source Code Pro"
                  mb={2}
                >
{t('events.description')}
                </Text>
                <Text 
                  fontSize="md" 
                  lineHeight="1.6"
                  color="gray.600"
                  fontFamily="Source Code Pro"
                  mb={0}
                  fontStyle="italic"
                >
{t('events.details')}
                </Text>
              </Box>
            </Box>
            <Box w={{ base: "100%", lg: "500px" }} h={{ base: "300px", lg: "400px" }} border="4px solid black">
              <Image
                src="/images/film-photography-events-tarifa.jpg"
alt={t('events.imageAlt')}
                w="100%"
                h="100%"
                objectFit="cover"
                loading="lazy"
              />
            </Box>
          </Flex>
        </Box>

        {/* Portrait Photography */}
        <Box 
          bg="white"
        >
          <Flex direction={{ base: "column", lg: "row" }} align="stretch">
            <Box w={{ base: "100%", lg: "500px" }} h={{ base: "300px", lg: "400px" }} border="4px solid black">
              <Image
                src="/images/people/person0.jpg"
                alt={t('portraits.imageAlt')}
                w="100%"
                h="100%"
                objectFit="cover"
                loading="lazy"
              />
            </Box>
            <Box flex="1" p={{ base: 6, md: 10 }} position="relative">
              <Box 
                position="absolute"
                top="0"
                right="0"
                w="60px"
                h="2px"
                bg="black"
                mb={4}
              />
              
              <Box pt={6}>
                <Text 
                  fontSize="sm" 
                  color="gray.500"
                  fontFamily="Source Code Pro"
                  textTransform="uppercase"
                  letterSpacing="2px"
                  mb={2}
                  textAlign="right"
                >
                  {t('portraits.number')} / {t('portraits.label')}
                </Text>
                <Text 
                  fontSize={{ base: "3xl", md: "4xl" }} 
                  fontWeight="bold" 
                  color="black"
                  fontFamily="Abel"
                  mb={4}
                  lineHeight="1.1"
                  textAlign="right"
                >
                  {t('portraits.title')}
                </Text>
                <Text 
                  fontSize="lg" 
                  lineHeight="1.6"
                  color="gray.700"
                  fontFamily="Source Code Pro"
                  mb={2}
                  textAlign="right"
                >
                  {t('portraits.description')}
                </Text>
                <Text 
                  fontSize="md" 
                  lineHeight="1.6"
                  color="gray.600"
                  fontFamily="Source Code Pro"
                  mb={0}
                  fontStyle="italic"
                  textAlign="right"
                >
                  {t('portraits.details')}
                </Text>
              </Box>
            </Box>
          </Flex>
        </Box>

        {/* Artistic Projects */}
        <Box 
          bg="white"
        >
          <Flex direction={{ base: "column", lg: "row" }} align="stretch">
            <Box flex="1" p={{ base: 6, md: 10 }} position="relative">
              <Box 
                position="absolute"
                top="0"
                left="0"
                w="60px"
                h="2px"
                bg="black"
                mb={4}
              />
              
              <Box pt={6}>
                <Text 
                  fontSize="sm" 
                  color="gray.500"
                  fontFamily="Source Code Pro"
                  textTransform="uppercase"
                  letterSpacing="2px"
                  mb={2}
                >
                  {t('projects.number')} / {t('projects.label')}
                </Text>
                <Text 
                  fontSize={{ base: "3xl", md: "4xl" }} 
                  fontWeight="bold" 
                  color="black"
                  fontFamily="Abel"
                  mb={4}
                  lineHeight="1.1"
                >
                  {t('projects.title')}
                </Text>
                <Text 
                  fontSize="lg" 
                  lineHeight="1.6"
                  color="gray.700"
                  fontFamily="Source Code Pro"
                  mb={2}
                >
                  {t('projects.description')}
                </Text>
                <Text 
                  fontSize="md" 
                  lineHeight="1.6"
                  color="gray.600"
                  fontFamily="Source Code Pro"
                  mb={0}
                  fontStyle="italic"
                >
                  {t('projects.details')}
                </Text>
              </Box>
            </Box>
            <Box w={{ base: "100%", lg: "500px" }} h={{ base: "300px", lg: "400px" }} border="4px solid black">
              <Image
                src="/images/wim/amster2.jpg"
                alt={t('projects.imageAlt')}
                w="100%"
                h="100%"
                objectFit="cover"
                loading="lazy"
              />
            </Box>
          </Flex>
        </Box>


      </VStack>

      {/* Service Areas & Process */}
      <Box mt={20} mb={16}>
        <Flex direction={{ base: "column", md: "row" }} gap={12} px={4}>
          {/* Service Areas */}
          <Box 
            flex="1" 
            textAlign="center" 
            bg="white" 
            p={8} 
            border="4px solid black"
          >
            <Text 
              fontSize={{ base: "xl", md: "2xl" }} 
              fontWeight="bold" 
              mb={6}
              color="black"
              fontFamily="Abel"
            >
              {t('serviceAreas.title')}
            </Text>
            <Box w="40px" h="2px" bg="black" mx="auto" mb={6} />
            <Text fontSize="md" color="black" lineHeight="1.8" fontFamily="Source Code Pro">
              {t('serviceAreas.locations')}
            </Text>
          </Box>

          {/* How It Works */}
          <Box 
            flex="1" 
            textAlign="center" 
            bg="white" 
            p={8} 
            border="4px solid black"
          >
            <Text 
              fontSize={{ base: "xl", md: "2xl" }} 
              fontWeight="bold" 
              mb={6}
              color="black"
              fontFamily="Abel"
            >
              {t('contact.title')}
            </Text>
            <Box w="40px" h="2px" bg="black" mx="auto" mb={6} />
            <Text fontSize="md" color="black" lineHeight="1.8" fontFamily="Source Code Pro">
              {t('contact.email')}
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* Contact CTA */}
      <Box 
        textAlign="center" 
        p={{ base: 8, md: 12 }} 
        bg="black"
        border="4px solid black"
        mx={4}
        mb={8}
        color="white"
      >
        <Text 
          fontSize={{ base: "2xl", md: "3xl" }} 
          fontWeight="bold" 
          mb={6}
          fontFamily="Abel"
          color="white"
        >
          {t('cta.title')}
        </Text>
        <Text 
          fontSize={{ base: "lg", md: "xl" }} 
          mb={8} 
          color="white"
          maxW="600px"
          mx="auto"
          lineHeight="1.6"
          fontFamily="Source Code Pro"
        >
          {t('cta.description')}
        </Text>
        <VStack spacing={4}>
          <Button 
            as={Link} 
            href="mailto:algranoconpablo@gmail.com?subject=Film Photography Inquiry"
            bg="white"
            color="black"
            size="lg"
            px={8}
            py={6}
            fontSize="lg"
            fontWeight="bold"
            fontFamily="Abel"
            border="2px solid white"
            _hover={{ 
              textDecoration: 'none',
              bg: "transparent",
              color: "white",
              border: "2px solid white"
            }}
          >
            {t('cta.button')}
          </Button>
          <Text fontSize="md" color="white" fontFamily="Source Code Pro">
            {t('cta.contactInfo')}
          </Text>
        </VStack>
      </Box>

    </Box>
  );
};

export default Services;